import DoneSharpIcon from "@mui/icons-material/DoneSharp";
import {
  Avatar,
  Box,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  styled,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { allIcons, allImages } from "../../../assets";

const MainView = styled(Box)(({ theme }) => ({
  position: "relative",
  backgroundColor: "#ffffff",
  maxWidth: "1200px",
  margin: "auto",
  padding: "16px",

  "& .lpl_gr_gr": {
    fontWeight: 700,
    fontSize: "2.5rem",
    textAlign: "center",
    background: "linear-gradient(90deg, #EA580C 0%, #000000 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    marginBottom: "3rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "2rem",
    },
  },
  "& .lpl_gr_tab_con:hover .lpl_gr_tab_img": {
    boxShadow: "6.67px -6.67px 6.67px 0px #EA580C1A inset",
    backgroundColor: "#EA580C1A",
  },
  "& .lpl_gr_tab_con:hover .lpl_gr_tab_title": {
    color: "#EA580C",
  },
  "& .lpl_gr_tab_img": {
    borderRadius: 12,
    height: 100,
    width: 100,
    padding: 20,
    boxShadow: "6.67px -6.67px 6.67px 0px #A5A5A51A inset",
    transition:
      "box-shadow 0.3s ease-in-out, background-color 0.3s ease-in-out",
  },
}));

let renderData = [
  {
    icon: allIcons.landingBagIcon,
    activeIcon: allIcons.landingBagColorIcon,
    title: "Booking",
  },
  // {
  //   icon: allIcons.landingAlarmIcon,
  //   activeIcon: allIcons.landingAlarmColorIcon,
  //   title: "Time Tracking",
  // },
  {
    icon: allIcons.landingDashboardIcon,
    activeIcon: allIcons.landingDashboardColorIcon,
    title: "Dashboard",
  },
  {
    icon: allIcons.landingLiveChatIcon,
    activeIcon: allIcons.landingLiveChatColorIcon,
    title: "Live Chat",
  },
  {
    icon: allIcons.landingTagIcon,
    activeIcon: allIcons.landingTagColorIcon,
    title: "Sales Report",
  },
  {
    icon: allIcons.landingBookIcon,
    activeIcon: allIcons.landingBookColorIcon,
    title: "Catalog",
  },
];

let functionalities = [
  "Today Sales report",
  "Sale services report",
  "Profit",
  "Today complete details report",
  "Services categories sale",
  "Graphical representation",
];

function GrowBussiness() {
  const [hoverIndex, setHoverIndex] = useState(null);
  const [activeTab, setActiveTab] = useState("Booking");

  const handleMouseEnter = (index) => {
    setHoverIndex(index);
  };

  const handleMouseLeave = () => {
    setHoverIndex(null);
  };

  const renderTabs = (data) => {
    return (
      <Stack
        gap={5}
        direction={"row"}
        alignItems={"center"}
        justifyContent={{ xs: "flex-start", md: "center" }}
        whiteSpace={"nowrap"}
        overflow={"auto"}
        sx={{ cursor: "pointer" }}
      >
        {data.map((val, ind) => (
          <Stack
            key={ind}
            alignItems={"center"}
            gap={1}
            onClick={() => setActiveTab(val?.title)}
            className="lpl_gr_tab_con"
            onMouseEnter={() => handleMouseEnter(ind)}
            onMouseLeave={handleMouseLeave}
          >
            <Avatar
              src={
                hoverIndex === ind || activeTab == val?.title
                  ? val.activeIcon
                  : val.icon
              }
              className="lpl_gr_tab_img"
            />
            <Typography
              variant="body1"
              color={hoverIndex === ind ? "#EA580C" : "#A6A9AC"}
              className="lpl_gr_tab_title"
            >
              {val.title}
            </Typography>
          </Stack>
        ))}
      </Stack>
    );
  };

  const renderFunctionlities = (data) => {
    return (
      <List>
        {data.map((val, index) => (
          <ListItem key={index} sx={{ px: 0 }}>
            <ListItemIcon sx={{ minWidth: 35 }}>
              <DoneSharpIcon htmlColor="#000000" />
            </ListItemIcon>
            <ListItemText
              primary={val}
              sx={{
                "& .MuiListItemText-primary": {
                  color: "#161C2D",
                },
              }}
            />
          </ListItem>
        ))}
      </List>
    );
  };

  return (
    <MainView my={{ xs: 3, md: 6 }}>
      <Typography variant="h1" className="lpl_gr_gr">
        Get your business to grow fast
      </Typography>
      {renderTabs(renderData)}
      <Grid container spacing={2} mt={5}>
        <Grid item xs={12} md={3}>
          <Typography variant="h4">Functionalities</Typography>
          {renderFunctionlities(functionalities)}
        </Grid>
        <Grid item xs={12} md={9}>
          <img
            src={
              activeTab == "Booking"
                ? allImages.bookingImage
                : activeTab == "Dashboard"
                ? allImages.dashboardImage
                : activeTab == "Live Chat"
                ? allImages.chatImage
                : activeTab == "Sales Report"
                ? allImages.ReportingImage
                : allImages.CatalogeImage
            }
            alt={"dashboard-cover-image"}
            width={"100%"}
            style={{
              boxShadow: "0px 42px 44px -10px rgba(1, 23, 48, 0.12)",
              border: "1px solid #e3e3e3",
              borderRadius: "6px",
            }}
          />
        </Grid>
      </Grid>
    </MainView>
  );
}

export default GrowBussiness;
